export function hasSportsContinuation(state) {
  return Boolean(
    state.sportsFeedModern &&
      state.hasMore &&
      state.sportsNextCursor &&
      (state.sportsPendingContinuation || !state.rawRows.length)
  );
}

/** Absence from the first page is not an unlisting; visible-card refresh verifies removals. */
export function mergeSportsFirstPage(previous, incoming) {
  const fresh = new Set(incoming.map((row) => String(row.id)));
  return incoming.concat(previous.filter((row) => !fresh.has(String(row.id))));
}

/** Only requested visible cards may be replaced or removed by the server. */
export function applySportsCardRefresh(previous, requestedIds, incoming) {
  if (!Array.isArray(incoming)) throw new Error('Invalid sports card response');
  const requested = new Set(requestedIds.map(String));
  const byId = new Map();
  for (const row of incoming) {
    const id = String(row?.id ?? '');
    if (!requested.has(id) || byId.has(id) || row.sportsFeed !== true) {
      throw new Error('Unexpected sports card identity');
    }
    byId.set(id, row);
  }
  return previous.flatMap((row) => {
    const id = String(row.id);
    if (!requested.has(id)) return [row];
    return byId.has(id) ? [byId.get(id)] : [];
  });
}

export function visibleSportsRequestIds(rows, visibleIds, limit = 32) {
  const visible = new Set(visibleIds.map(String));
  return rows
    .filter((row) => row.sportsFeed === true && visible.has(String(row.id)))
    .map((row) => String(row.id))
    .slice(0, limit);
}
